<div class="w-full h-full">
  <canvas
    baseChart
    [data]="chartData"
    [options]="chartOptions"
    [type]="chartType"
    [legend]="chartLegend">
  </canvas>
</div>
